import React from "react";
import NewsFormPage from "../components/news/NewsFormPage";

const NewsCreate = () => <NewsFormPage mode="create" />;

export default NewsCreate;
